import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';

import { IDiscoverItem, INationalityFilter } from 'app/interfaces/discover.interfaces';

@Component({
  selector: 'stxt-dropdown-filter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dropdown-filter.component.html',
  styleUrl: './dropdown-filter.component.scss'
})
export class DropdownFilterComponent implements OnInit {
  @Input() filters: IDiscoverItem[] | INationalityFilter[];
  @Input() selectedFilters: INationalityFilter[];
  @Output() filterSelected: EventEmitter<INationalityFilter[]> = new EventEmitter<
    INationalityFilter[]
  >();
  filtersList: INationalityFilter[] = [];

  constructor(public readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.filtersList = this.selectedFilters;
  }

  isChecked(filterId: string): boolean {
    return this.filtersList?.some(filter => filter.nationality === filterId);
  }

  selectFilter(filter: INationalityFilter): void {
    const index = this.filtersList.indexOf(filter);
    index === -1 ? this.filtersList.push(filter) : this.filtersList.splice(index, 1);
    this.cdr.detectChanges();
    this.filterSelected.emit(this.filtersList);
  }
}
